/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, EventEmitter, Output, ViewChild, OnInit, Input, OnDestroy } from '@angular/core';
import { ReportFilter } from '../../../model/report-filter';
import { UserProvider, ReportProvider, PreferenceProvider, ClientProvider, ErrorProvider, TagProvider } from '../../../providers';
import { Helpers, State, Stage, Client, User, PreferenceRequest, FilterPreference } from 'src/app/model';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Preference } from 'src/app/model/preference';
import { ConfirmDeletePreferenceModal } from '../../pages/dashboard/modal/confirm-delete-preference/confirm-delete-preference.modal';
import { DelayType } from 'src/app/model/report';
import { CreatePreferenceModal, UpdatePreferenceModal } from '../../modal';
import { DashboardService, UserService, ModeService, StageService } from 'src/app/services';
import { CrmError } from 'src/app/model/error';
import { FeedbackModal } from '../toast/feedback/feedback.modal';
import { Tag } from 'src/app/model/tag';
import { SystemType } from 'src/app/model/enums/system.type';
import { ActivatedRoute, Router } from '@angular/router';
import { PresetValue } from 'src/app/model/preset-value';
import { LogService } from 'src/app/services';

@Component({
  selector: 'app-dashboard-filter',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit, OnDestroy {
  @ViewChild('filterDropdown') filterDropdown;
  @ViewChild('filterDropdownPreference') filterDropdownPreference;
  @ViewChild('filterDropdownSort') filterDropdownSort;

  @Input() page: number = 1;
  @Input() stages: Stage[];
  @Input() states: State[];
  @Input() showStates: boolean = true;
  @Input() showStages: boolean = true;
  @Input() isFullWidth: boolean = false;
  @Input() showQuoteFilter: boolean = true;

  preferences: Preference[] = [];
  savedPreferences: Preference[] = [];
  preference: Preference;
  filterPreference: FilterPreference = new FilterPreference();
  /* @Input() isChanged: boolean = false; */
  /*  column: string;
  isDesc: boolean; */
  /* sliderValue: number; */
  @Input() styleFlag: boolean = true; // show/hide style control
  @Input() reportsLoading: boolean = false;
  @Output() filterChanged = new EventEmitter<FilterPreference>();
  @Output() onDelete = new EventEmitter<string[]>();
  @Output() onChangeValue = new EventEmitter<any>();

  constructor(
    private userProvider: UserProvider,
    private reportProvider: ReportProvider,
    private preferenceProvider: PreferenceProvider,
    private clientProvider: ClientProvider,
    private modalService: BsModalService,
    private dashboardService: DashboardService,
    private userService: UserService,
    private errorProvider: ErrorProvider,
    public tagProvider: TagProvider,
    private modeService: ModeService,
    private route: ActivatedRoute,
    private stageService: StageService,
    private router: Router,
    private logService :LogService
  ) {
  }

  filter: ReportFilter = new ReportFilter('NO_FILTER');
  saveFilter: ReportFilter = new ReportFilter('NO_SELECTED');

  miscs: PresetValue[] = [
    PresetValue.create("Researched", "RESEARCHED"),
    PresetValue.create("Not Researched", "NOT_RESEARCHED"),
    PresetValue.create("Spreaded", "SPREADED"),
    PresetValue.create("Not Spreaded", "NOT_SPREADED")
  ];

  searchUsers: User[];
  searchProcessor: User[];
  searchResearchAnalyst: User[];
  searchFinancialAnalyst: User[];
  searchSeniorAnalyst: User[];
  searchBanks: Client[];
  searchTags: Tag[];
  DelayType = DelayType;

  searchEaProcessor: User[];
  searchEaResearchAnalyst: User[];
  searchEaAppraiser: User[];
  searchEaReviewer: User[];

  preferenceRequest: PreferenceRequest;

  createModal: BsModalRef;
  deleteModal: BsModalRef;
  feedbackRef: BsModalRef;

  userSub: any;
  processorSub: any;
  raSub: any;
  faSub: any;
  saSub: any;
  clientSub: any;
  tagSub: any;

  //Report Ea
  eqpSub: any;
  eqraSub: any;
  eqaSub: any;
  eqrSub: any;
  eqsSub: any;

  loading: boolean = false;
  currentMode: SystemType;
  modeSub: any;
  Mode = SystemType;
  preferencesSub: any;
  preferenceSub: any;
  paramSub: any;
  paramStats: string = null;

  // Selected
  filterLimit: any = {
    state: {
      min: 0,
      max: 5
    },
    stage: {
      min: 0,
      max: 5
    },
    assignee: {
      min: 0,
      max: 5
    },
    processor: {
      min: 0,
      max: 5
    },
    researchAnalyst: {
      min: 0,
      max: 5
    },
    financialAnalyst: {
      min: 0,
      max: 5
    },
    seniorAnalyst: {
      min: 0,
      max: 5
    },
    bank: {
      min: 0,
      max: 5
    },
    tags: {
      min: 0,
      max: 5
    },
    eqprocessor: {
      min: 0,
      max: 5
    },
    eqresearchAnalyst: {
      min: 0,
      max: 5
    },
    eqAppraiser: {
      min: 0,
      max: 5
    },
    eqReviewer: {
      min: 0,
      max: 5
    },
    misc: {
      min: 0,
      max: 5
    }
  };

  ngOnInit(): void {

    this.paramSub = this.route.queryParams.subscribe(params => {
      if (params)
        this.paramStats = params.stats;
      else
        this.paramStats = null;
    });

    this.preferencesSub = this.dashboardService.preferences$.subscribe(preferences => this.preferences = preferences.filter(p=> p.TYPE === this.currentMode));

    this.modeSub = this.modeService.mode$.subscribe(mode => {

      if(mode && this.currentMode){
        if (mode !== this.currentMode) {
          this.preference = null;
          this.dashboardService.preference.next(null);
          this.stages.map(s => s.selected = false);
          this.states.map(s => s.selected = false);
        }
      }

      if(mode){
        this.currentMode = mode;

        if (this.dashboardService.preferences.getValue()) {
          this.preferences = this.dashboardService.preferences.getValue().filter(p => p.TYPE === this.currentMode);
        }

        this.filterPreference = new FilterPreference();
        this.initPreferences();
        //this.loadPreference();
      }
    });

    // Users for Search in Filters
    this.userSub = this.dashboardService.users$.subscribe(users => {
      if (users) {
        this.searchUsers = User.parseArray(users);
      }
    });

    // Processors for Search in Filters
    this.processorSub = this.dashboardService.processors$.subscribe(users => {
      if (users) {
        this.searchProcessor = User.parseArray(users);
      }
    });

    // Research Analysts for Search in Filters
    this.raSub = this.dashboardService.researchAnalysts$.subscribe(users => {
      if (users) {
        this.searchResearchAnalyst = User.parseArray(users);
      }
    });

    // Financial Analysts for Search in Filters
    this.faSub = this.dashboardService.financialAnalysts$.subscribe(users => {
      if (users) {
        this.searchFinancialAnalyst = User.parseArray(users);
      }
    });

    // Senior Analysts for Search in Filters
    this.saSub = this.dashboardService.seniorAnalysts$.subscribe(users => {
      if (users) {
        this.searchSeniorAnalyst = User.parseArray(users);
      }
    });

    // Clients for Search in Filter
    this.clientSub = this.dashboardService.clients$.subscribe(clients => {
      if (clients) {
        this.searchBanks = Client.parseArray(clients);
      }
    });

    // Tags for Search in Filter
    this.tagSub = this.dashboardService.tags$.subscribe(tags => {
      if (tags) {
        this.searchTags = Tag.parseArray(tags);
      }
    });

    // Equipment Processor
    this.eqpSub = this.dashboardService.eqprocessors$.subscribe(users => {
      if (users){
        this.searchEaProcessor = User.parseArray(users);
      }
    });

    // Equipment Research Analyst
    this.eqraSub = this.dashboardService.eqresearchAnalysts$.subscribe(users => {
      if (users) {
        this.searchEaResearchAnalyst = User.parseArray(users);
      }
    });

    // Equipment Appraiser
    this.eqaSub = this.dashboardService.eqAppraiser$.subscribe(users => {
      if (users) {
        this.searchEaAppraiser = User.parseArray(users);
      }
    });

    // Equipment Reviewer
    this.eqrSub = this.dashboardService.eqReviewer$.subscribe(users => {
      if (users) {
        this.searchEaReviewer = User.parseArray(users);
      }
    });
  }

  ngOnDestroy(): void {
    if(this.userSub)
      this.userSub.unsubscribe();

    if(this.processorSub)
      this.processorSub.unsubscribe();

    if(this.raSub)
      this.raSub.unsubscribe();

    if(this.faSub)
      this.faSub.unsubscribe();

    if(this.saSub)
      this.saSub.unsubscribe();

    if(this.clientSub)
      this.clientSub.unsubscribe();

    if (this.modeSub)
      this.modeSub.unsubscribe();

    if(this.eqpSub)
      this.eqpSub.unsubscribe();

    if(this.eqraSub)
      this.eqraSub.unsubscribe();

    if (this.eqaSub)
      this.eqaSub.unsubscribe();

    if(this.eqrSub)
      this.eqrSub.unsubscribe();

    if(this.paramSub)
      this.paramSub.unsubscribe();

  }

  initPreferences(): void {
    if (this.preferences.length === 0) {
      this.preferenceProvider.getPreferences().subscribe(data => {
        if (data.success) {
          this.savedPreferences = Preference.parseArray(data.result);
          this.dashboardService.setPreferences(this.savedPreferences);
          this.loadPreference();
        }
      });
    }
    else {
      this.saveFilter = new ReportFilter('NO_SELECTED');
      this.loadPreference();
    }
  }

  loadPreference(): void {
    if(this.paramStats){
      this.preferences.map(f => f.SELECTED = false);
      this.saveFilter = new ReportFilter('NO_SELECTED');
      this.loadParams();
    }
    else {
      if (this.dashboardService.preference.getValue()) {
        this.filterPreference = this.dashboardService.preference.getValue();

        if (this.preferences.length > 0) {
          this.preference = this.preferences.find(f => f.SELECTED === true);
        }

        if(this.preference){
          this.filter = new ReportFilter('PREFERENCE');
          this.saveFilter = new ReportFilter('PREFERENCE');
          this.filter.VALUE = this.preference.NAME;
          this.saveFilter.VALUE = this.preference.NAME;
        }

        this.filterValueChanged();

      }
      else {
        this.getPreference();
      }
    }
  }

  getPreference(): void {
    if (this.preferences.length > 0) {
      this.preference = this.preferences.find(f => f.SELECTED === true);
    }

    if (this.preference == null) {
      this.retrieveSaveColumns();
      this.filterValueChanged();
    }
    else {
      this.selectedPreference(this.preference);
    }
  }

  filterValueChanged(): void {

    if (this.filterPreference.isChanged) {
      this.dashboardService.preference.next(this.filterPreference);
    }

    this.filterChanged.emit(this.filterPreference);
  }

  sortColumn(column: string): void {
    if (column === 'CREATE_DATE')
      this.filterPreference.isDesc = true;
    else this.filterPreference.isDesc = !this.filterPreference.isDesc;

    this.filterPreference.column = column;
    this.filterPreference.isChanged = true;
    this.page = 1;

    this.saveSortColumn();
    this.filterValueChanged();
  }

  onSavePreference(): void {
    if (this.preference == null)
      this.preference = new Preference();

    this.preference.ORDER = this.filterPreference.column;
    this.preference.SORT = this.filterPreference.isDesc;
    this.preference.SIZE = this.filterPreference.size;
    this.preference.STATE = this.filterPreference.getStates();
    this.preference.STAGE = this.filterPreference.getStages();

    this.preference.BANK = this.filterPreference.getBanks();
    this.preference.DELAYED_TYPE = this.filterPreference.getDelay();
    this.preference.TAGS = this.filterPreference.getTags();
    this.preference.SLIDER_VALUE = this.filterPreference.sliderValue;
    this.preference.TYPE = this.currentMode;
    this.preference.MISC = this.filterPreference.getMics();
/*     this.preference.SHOW_RESEARCHED = this.filterPreference.showResearched;
    this.preference.SHOW_SPREADED = this.filterPreference.showSpreaded; */

    if(this.currentMode == SystemType.EA){
      this.preference.PROCESSOR = null;
      this.preference.RESEARCH_ANALYST = null;
      this.preference.FINANCIAL_ANALYST = null;
      this.preference.SENIOR_ANALYST = null;
      this.preference.BANK = this.filterPreference.getBanks();
      this.preference.EQUIPMENT_PROCESSOR = this.filterPreference.getEaProcessor();
      this.preference.EQUIPMENT_RESEARCH_ANALYST = this.filterPreference.getEaResearchAnalyst();
      this.preference.EQUIPMENT_APPRAISER = this.filterPreference.getEaAppraiser();
      this.preference.EQUIPMENT_REVIEWER = this.filterPreference.getEaReviewer();
    }
    else {
      this.preference.EQUIPMENT_PROCESSOR = null;
      this.preference.EQUIPMENT_RESEARCH_ANALYST = null;
      this.preference.EQUIPMENT_APPRAISER = null;
      this.preference.EQUIPMENT_REVIEWER = null;

      this.preference.ASSIGNEE = this.filterPreference.getAssignee();
      this.preference.PROCESSOR = this.filterPreference.getProcessor();
      this.preference.RESEARCH_ANALYST = this.filterPreference.getResearchAnalyst();
      this.preference.FINANCIAL_ANALYST = this.filterPreference.getFinancialAnalyst();
      this.preference.SENIOR_ANALYST = this.filterPreference.getSeniorAnalyst();
    }

    if (this.saveFilter.FIELD === 'NO_SELECTED') {
      this.createModal = this.modalService.show(CreatePreferenceModal, Helpers.getModalConfig());
      const ackSubject = new Subject<Preference>();
      this.createModal.content.subject = ackSubject;
      this.createModal.content.preference = this.preference;

      ackSubject.subscribe(value => {
        if (value) {
          this.preference = value;
          this.preference.SELECTED = true;
          this.filter = new ReportFilter('PREFERENCE');
          this.saveFilter = new ReportFilter('PREFERENCE');
          this.filter.VALUE = this.preference.NAME;
          this.saveFilter.VALUE = this.preference.NAME;
          this.preferences.push(this.preference);
          this.dashboardService.preferences.getValue().push(this.preference);
          this.filterPreference.isChanged = false;
          this.dashboardService.preference.next(null);
        }
      });
    } else if (this.filterPreference.isChanged) {
      this.createModal = this.modalService.show(UpdatePreferenceModal, Helpers.getModalConfig());
      const ackSubject = new Subject<any>();
      this.createModal.content.subject = ackSubject;
      this.createModal.content.preference = this.preference;
      ackSubject.subscribe(value => {

        if (value.ACTION === 'CREATE_NEW') {

          this.preference = Preference.parse(value.PREFERENCE);
          this.preference.SELECTED = true;
          this.filter = new ReportFilter('PREFERENCE');
          this.saveFilter = new ReportFilter('PREFERENCE');
          this.filter.VALUE = this.preference.NAME;
          this.saveFilter.VALUE = this.preference.NAME;
          this.preferences.push(this.preference);
          this.dashboardService.preferences.getValue().push(this.preference);
          const currentPreference = this.preferences.find(pref => pref.SELECTED === true && pref.ID !== this.preference.ID);

          for (const ps of this.preferences) {
            if (ps.ID !== this.preference.ID) {
              ps.SELECTED = false;
            }
          }

          if (currentPreference != null) {
            this.preferenceProvider.save(currentPreference.ID, 'SELECTED', false).subscribe(data => {
              if (!data.success) {
                this.logService.error(JSON.stringify(data, null, 2));
              }
            });
          }

          this.filterPreference.isChanged = false;
        } else if (value.ACTION === 'UPDATE') {
          this.filterPreference.isChanged = false;
        }

      });
    }
  }

  getFilterFieldText(): string {
    let returnText = '';

    // STATE
    if (this.filterPreference.selectedStates.length > 0) {
      returnText += returnText ? ', State' : 'State';
    }

    // STAGE
    if (this.filterPreference.selectedStages.length > 0) {
      returnText += returnText ? ', Stage' : 'Stage';
    }

    // ASSIGNEE
    if (this.filterPreference.selectedAssignee.length > 0) {
      returnText += returnText ? ', Assignee' : 'Assignee';
    }

    // PROCESSOR
    if (this.filterPreference.selectedProcessor.length > 0) {
      returnText += returnText ? ', Processor' : 'Processor';
    }

    // RESEARCH ANALYST
    if (this.filterPreference.selectedResearchAnalyst.length > 0) {
      returnText += returnText ? ', Research Analyst' : 'Research Analyst';
    }

    // FINANCIAL ANALYST
    if (this.filterPreference.selectedFinancialAnalyst.length > 0) {
      returnText += returnText ? ', Financial Analyst' : 'Financial Analyst';
    }

    // SENIOR ANALYST
    if (this.filterPreference.selectedSeniorAnalyst.length > 0) {
      returnText += returnText ? ', Senior Analyst' : 'Senior Analyst';
    }

    // BANK
    if (this.filterPreference.selectedBanks.length > 0) {
      returnText += returnText ? ', Bank' : 'Bank';
    }

    // DELAY
    if (this.filterPreference.selectedDelay) {
      returnText += returnText ? ', Delay' : 'Delay';
    }

    //MISC
    if (this.filterPreference.selectedMiscs.length > 0) {
      returnText += returnText ? ', Misc' : 'Misc';
    }

    if (!returnText)
      return 'No Filtering';
    else
      return returnText;
  }

  getSortOrderName(): string {
    switch (this.filterPreference.column) {
    case 'CREATED_DATE':
      return 'Create Date';
    case 'UPDATE_DATE':
      return 'Update Date';
    case 'ENGAGED_DATE':
      return 'Engaged Date';
    case 'CLIENT':
      return 'Company Name';
    case 'DUE_DATE':
      return 'Due Date';
    case 'STAGE':
      return 'State / Stage';
    case 'PROGRESS':
      return 'Progress';
    case 'ASSIGNEE':
      return 'Assignee';
    case 'BANK':
      return 'Bank';
    case 'FOLLOW_UP_DATE':
      return 'Follow Up Date';
    }
    return 'N/A';
  }

  clearFilterFieldName(): string {
    switch (this.saveFilter.FIELD) {
    case 'NO_SELECTED':
      return 'No Selected';
    case 'PREFERENCE':
      return this.saveFilter.VALUE;
    default:
      return '';
    }
  }

  // Custom and Multiple
  onStateValueChanged(state: State, event: any): void {
    if (event) {
      this.filterPreference.selectedStates.push(state);
    } else {
      this.clearState(state, 'STATE');
    }
    this.setFilterBy('STATE');
  }

  onStageValueChanged(stage: Stage, event: any): void {
    if (event) {
      this.filterPreference.selectedStages.push(stage);
    } else {
      this.clearStage(stage, 'STAGE');
    }
    this.setFilterBy('STAGE');
  }

  //Clearing Filter
  clearFilterBy(type: string): void {
    if (type === 'NO_SELECTED') {
      this.preferences.map(f => f.SELECTED = false);
      if (this.preference != null) {
        this.preferenceProvider.save(this.preference.ID, 'SELECTED', false).subscribe(data => {
          if (data.success) {
            this.preference = new Preference();
          }
        });
      }
      this.saveFilter = new ReportFilter('NO_SELECTED');
      if (this.filterDropdown)
        this.filterDropdown.hide();
      this.setFilterBy('NO_FILTER');
      this.filterPreference.isChanged = false;
    }
  }

  //Deleting saved Filter
  deleteFilter(p: Preference): void {
    this.deleteModal = this.modalService.show(ConfirmDeletePreferenceModal, Helpers.getModalConfig());
    const ackSubject = new Subject<Boolean>();
    this.deleteModal.content.subject = ackSubject;

    ackSubject.subscribe(result => {
      if (result) {
        this.preferenceProvider.deletePreference(p).subscribe(data => {
          if (data.success) {
            if (p.SELECTED)
              this.clearFilterBy('NO_SELECTED');
            this.preferences.splice(this.preferences.indexOf(p), 1);
            this.dashboardService.preferences.getValue().splice(this.preferences.indexOf(p), 1);
          }
        });
      }
    });
  }

  setFilterBy(type: string): void {
    if (type === 'NO_FILTER') {

      this.filterPreference.clear();
      if (this.showStates) this.states.map(state => state.selected = false);
      if (this.showStages) this.stages.map(stage => stage.selected = false);
      this.filter = new ReportFilter('NO_FILTER');
      if (this.filterDropdown)
        this.filterDropdown.hide();

      this.retrieveSaveColumns();
    }

    this.filterPreference.isChanged = true;
    this.filterValueChanged();
  }

  setDelay(): void {
    this.filterPreference.isChanged = true;
    this.filterValueChanged();
  }

  clearDelay(): void {
    this.filterPreference.selectedDelay = null;
    this.filterPreference.isChanged = true;
    this.filterValueChanged();
  }

  saveSortColumn(): void {
    localStorage.setItem('R-CRM-SORT_COLUMN', this.filterPreference.column);
    localStorage.setItem('R-CRM-SORT_ORDER', this.filterPreference.isDesc.toString());
    localStorage.setItem('R-CRM-SLIDER_VALUE', this.filterPreference.sliderValue.toString());
  }

  retrieveSaveColumns(): void {
    // eslint-disable-next-line no-prototype-builtins
    if (localStorage.hasOwnProperty('R-CRM-SORT_COLUMN')) {
      this.filterPreference.column = localStorage.getItem('R-CRM-SORT_COLUMN');
      /* this.column = localStorage.getItem('R-CRM-SORT_COLUMN'); */
    }

    // eslint-disable-next-line no-prototype-builtins
    if (localStorage.hasOwnProperty('R-CRM-SORT_ORDER')) {
      this.filterPreference.isDesc = localStorage.getItem('R-CRM-SORT_ORDER') === 'true' ? true : false;
      /*   this.isDesc = localStorage.getItem('R-CRM-SORT_ORDER') === 'true' ? true : false; */
    }

    // eslint-disable-next-line no-prototype-builtins
    if (localStorage.hasOwnProperty('R-CRM-SORT_SIZE')) {
      this.filterPreference.size = Number(localStorage.getItem('R-CRM-SORT_SIZE'));
      /*  this.selectedSize = Number(localStorage.getItem('R-CRM-SORT_SIZE'));
       this.currentSize = Number(localStorage.getItem('R-CRM-SORT_SIZE')); */
    }

    // eslint-disable-next-line no-prototype-builtins
    if (localStorage.hasOwnProperty('R-CRM-SLIDER_VALUE')) {
      this.filterPreference.sliderValue = Number(localStorage.getItem('R-CRM-SLIDER_VALUE'));
      /* this.onChangeValue({ value: this.filterPreference.sliderValue }); */
    }
  }

  //Load Selected Preference
  selectedPreference(preference: Preference): void {
    this.preferenceProvider.getPreference(preference.ID).subscribe(data => {
      if (data.success) {
        this.preferenceRequest = PreferenceRequest.parse(data.result);
        if (this.preferenceRequest) {
          this.filterPreference.isDesc = this.preferenceRequest.SORT;
          this.filterPreference.column = this.preferenceRequest.ORDER;
          this.filterPreference.selectedStates = this.preferenceRequest.STATE;
          this.filterPreference.selectedStages = this.preferenceRequest.STAGE;
          this.filterPreference.selectedAssignee = this.preferenceRequest.ASSIGNEE;
          this.filterPreference.selectedProcessor = this.preferenceRequest.PROCESSOR;
          this.filterPreference.selectedResearchAnalyst = this.preferenceRequest.RESEARCH_ANALYST;
          this.filterPreference.selectedFinancialAnalyst = this.preferenceRequest.FINANCIAL_ANALYST;
          this.filterPreference.selectedSeniorAnalyst = this.preferenceRequest.SENIOR_ANALYST;
          this.filterPreference.selectedBanks = this.preferenceRequest.BANK;
          this.filterPreference.selectedDelay = DelayType[<string>this.preferenceRequest.DELAYED_TYPE];
          this.filterPreference.size = this.preferenceRequest.SIZE ? this.preferenceRequest.SIZE : 10;
          this.filterPreference.selectedTags = this.preferenceRequest.TAGS;
          this.filterPreference.sliderValue = this.preferenceRequest.SLIDER_VALUE;
          this.filterPreference.showResearched = this.preferenceRequest.SHOW_RESEARCHED;
          this.filterPreference.showSpreaded = this.preferenceRequest.SHOW_SPREADED;
          this.filterPreference.selectedMiscs = this.preferenceRequest.MISC;
          this.filter = new ReportFilter('PREFERENCE');
          this.saveFilter = new ReportFilter('PREFERENCE');
          this.filter.VALUE = this.preferenceRequest.NAME;
          this.saveFilter.VALUE = this.preferenceRequest.NAME;
          this.preference = preference;
          this.filterPreference.isChanged = false;

          if (this.showStates) this.states.map(s => {
            if (this.filterPreference.selectedStates.find(sel => sel.ID === s.ID)) {
              s.selected = true;
            } else {
              s.selected = false;
            }
          });

          if (this.showStages) this.stages.map(s => {
            if (this.filterPreference.selectedStages.find(sel => sel.ID === s.ID)) {
              s.selected = true;
            } else {
              s.selected = false;
            }
          });

          if(this.paramStats){
            this.router.navigate(['/dashboard']);
            this.filterValueChanged();
          }
          else
            this.filterValueChanged();
        }
      }
    });
  }

  //Select Assignee
  selectFilterAssignee(user: User): void {
    const found = this.filterPreference.selectedAssignee.find(u => u.ID === user.ID);
    if (!found)
      this.filterPreference.selectedAssignee.push(user);

    this.setFilterBy('ASSIGNEE');
  }

  //Select Processor
  selectFilterProcessor(user: User): void {
    const found = this.filterPreference.selectedProcessor.find(u => u.ID === user.ID);
    if (!found)
      this.filterPreference.selectedProcessor.push(user);

    this.setFilterBy('PROCESSOR');
  }

  //Select Research Analyst
  selectFilterResearchAnalyst(user: User): void {
    const found = this.filterPreference.selectedResearchAnalyst.find(usr => usr.ID === user.ID);
    if (!found)
      this.filterPreference.selectedResearchAnalyst.push(user);

    this.setFilterBy('RESEARCH_ANALYST');
  }

  //Select Financial Analyst
  selectFilterFinancialAnalyst(user: User): void {
    const found = this.filterPreference.selectedFinancialAnalyst.find(usr => usr.ID === user.ID);
    if (!found)
      this.filterPreference.selectedFinancialAnalyst.push(user);

    this.setFilterBy('FINANCIAL_ANALYST');
  }

  //Select Senior Analyst
  selectFilterSeniorAnalyst(user: User): void {
    const found = this.filterPreference.selectedSeniorAnalyst.find(usr => usr.ID === user.ID);
    if (!found)
      this.filterPreference.selectedSeniorAnalyst.push(user);
    this.setFilterBy('SENIOR_ANALYST');
  }

  //Select Bank
  selectFilterBank(bank: Client): void {
    const found = this.filterPreference.selectedBanks.find(b => b.ID === bank.ID);
    if (!found)
      this.filterPreference.selectedBanks.push(bank);
    this.setFilterBy('BANK');
  }

  //Clear Selected State
  clearState(s: State, field: string): void {
    const index = this.filterPreference.selectedStates.findIndex(st => st.ID === s.ID);
    this.filterPreference.selectedStates.splice(index, 1);
    s.selected = false;
    this.setFilterBy(field);
  }

  //Clear Selected Stage
  clearStage(s: Stage, field: string): void {
    const index = this.filterPreference.selectedStages.findIndex(st => st.ID === s.ID);
    this.filterPreference.selectedStages.splice(index, 1);
    s.selected = false;
    this.setFilterBy(field);
    this.scrollFilter('stage', true);
  }

  //Clear Selected Bank
  clearBank(b: Client, field: string): void {
    const index = this.filterPreference.selectedBanks.findIndex(bnk => bnk.ID === b.ID);
    this.filterPreference.selectedBanks.splice(index, 1);
    this.setFilterBy(field);
    this.scrollFilter('bank', true);
  }

  //Clear Selected Assignee
  clearAssignee(u: User, field: string): void {
    const index = this.filterPreference.selectedAssignee.findIndex(usr => usr.ID === u.ID);
    this.filterPreference.selectedAssignee.splice(index, 1);
    this.setFilterBy(field);
    this.scrollFilter('assignee', true);
  }

  //Clear Selected Processor
  clearProcessor(u: User, field: string): void {
    const index = this.filterPreference.selectedProcessor.findIndex(usr => usr.ID === u.ID);
    this.filterPreference.selectedProcessor.splice(index, 1);
    this.setFilterBy(field);
    this.scrollFilter('processor', true);
  }

  //Clear Selected Research Analyst
  clearResearchAnalyst(u: User, field: string): void {
    const index = this.filterPreference.selectedResearchAnalyst.findIndex(usr => usr.ID === u.ID);
    this.filterPreference.selectedResearchAnalyst.splice(index, 1);
    this.setFilterBy(field);
    this.scrollFilter('researchAnalyst', true);
  }

  //Clear Selected Financial Analyst
  clearFinancialAnalyst(u: User, field: string): void {
    const index = this.filterPreference.selectedFinancialAnalyst.findIndex(usr => usr.ID === u.ID);
    this.filterPreference.selectedFinancialAnalyst.splice(index, 1);
    this.setFilterBy(field);
    this.scrollFilter('financialAnalyst', true);
  }

  //Clear Selected Senior Analyst
  clearSeniorAnalyst(u: User, field: string): void {
    const index = this.filterPreference.selectedSeniorAnalyst.findIndex(usr => usr.ID === u.ID);
    this.filterPreference.selectedSeniorAnalyst.splice(index, 1);
    this.setFilterBy(field);
    this.scrollFilter('seniorAnalyst', true);
  }

  //Clear Selected Tags
  clearTags(t: Tag, field: string): void {
    const index = this.filterPreference.selectedTags.findIndex(tag => tag.ID === t.ID);
    this.filterPreference.selectedTags.splice(index, 1);
    this.setFilterBy(field);
    this.scrollFilter('tags', true);
  }

  //Clear Selected Miscs
  clearMiscs(m: PresetValue, field: string): void {
    const index = this.filterPreference.selectedMiscs.findIndex(st => st.NAME === m.NAME);
    this.filterPreference.selectedMiscs.splice(index, 1);
    m.selected = false;
    this.setFilterBy(field);
    this.scrollFilter('misc', true);
  }

  onUserResult(value: string, position: string): void {
    this.userProvider.search(value, null, null, null, null, position)
      .subscribe(data => {
        if (data.success)
          switch (position) {
          case 'PROCESSOR':
            this.searchProcessor = User.parseArray(data.result.items);
            break;
          case 'RESEARCH_ANALYST':
            this.searchResearchAnalyst = User.parseArray(data.result.items);
            break;
          case 'FINANCIAL_ANALYST':
            this.searchFinancialAnalyst = User.parseArray(data.result.items);
            break;
          case 'SENIOR_ANALYST':
            this.searchSeniorAnalyst = User.parseArray(data.result.items);
            break;
          case 'EQUIPMENT_PROCESSOR':
            this.searchEaProcessor = User.parseArray(data.result.items);
            break;
          case 'EQUIPMENT_RESEARCH_ANALYST':
            this.searchEaResearchAnalyst = User.parseArray(data.result.items);
            break;
          case 'EQUIPMENT_APPRAISER':
            this.searchEaAppraiser = User.parseArray(data.result.items);
            break;
          case 'EQUIPMENT_REVIEWER':
            this.searchEaReviewer = User.parseArray(data.result.items);
            break;
          default:
            this.searchUsers = User.parseArray(data.result.items);
            break;
          }
      });
  }

  onBankResult(value: string): void {
    this.clientProvider.search(value)
      .subscribe(data => {
        if (data.success)
          this.searchBanks = Client.parseArray(data.result.items);
      });
  }

  //Preference Filter Selected Changed
  onFilterValueChanged(p: Preference, event: any): void {
    if (event) {
      const currentPreference = this.preferences.find(pref => pref.SELECTED === true && pref.ID !== p.ID);

      for (const ps of this.preferences) {
        if (ps.ID !== p.ID) {
          ps.SELECTED = false;
        }
      }

      if (currentPreference != null) {
        this.preferenceProvider.save(currentPreference.ID, 'SELECTED', false).subscribe(data => {
          if (!data.success) {
            this.logService.error(JSON.stringify(data, null, 2));
          }
        });
      }

      this.preferenceProvider.save(p.ID, 'SELECTED', event).subscribe(data => {
        if (!data.success) {
          this.logService.error(JSON.stringify(data, null, 2));
        }
      });
      this.selectedPreference(p);
    } else {
      this.clearFilterBy('NO_SELECTED');
    }

  }

  /**
   * Scroll to top-bottom in filtered list
  */
  scrollFilter(field: string, isTop: boolean): void {
    if (isTop) {
      if (this.filterLimit[field].min > 0) {
        this.filterLimit[field].min -= 1;
        this.filterLimit[field].max -= 1;
      }
    } else {
      this.filterLimit[field].min += 1;
      this.filterLimit[field].max += 1;
    }
  }

  getDelayName(): string {
    switch (this.filterPreference.selectedDelay) {
    case 'CLIENT':
      return 'Client Delay';
    case 'RELIANT':
      return 'Reliant Delay';
    case 'CURRENT':
      return 'Currently on Delay';
    }
    return '';
  }

  getAvatarLetters(name: string = ''): string {
    let returnStr = '';
    if (name) {
      const arr: string[] = name.split(' ');
      if (arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].charAt(0).match(/^[A-Za-z0-9]+$/))
            returnStr += arr[i].charAt(0);

          if (returnStr.length == 2)
            break;
        }
      }
    }
    if (returnStr)
      return returnStr;
    else
      return 'UU';
  }

  preventClose(event: MouseEvent): void {
    event.stopImmediatePropagation();
  }

  onSendFeedBack(): void {
    const details: CrmError = new CrmError();
    details.TYPE = null;
    details.DATE = new Date();
    details.USER = User.parse(this.userService.getCurrentUser()),
    details.MESSAGE = '';
    details.URL = window.location.href;

    this.feedbackRef = this.modalService.show(FeedbackModal, Helpers.getModalConfig());
    const ackSubject = new Subject<boolean>();
    this.feedbackRef.content.subject = ackSubject;
    this.feedbackRef.content.details = details;


    ackSubject.subscribe(value => {
      if (value) {
        this.errorProvider.sendFeedback(details)
          .subscribe(data => {
            if (!data.success) {
              this.logService.error(JSON.stringify(data, null, 2));
            }
          });
      }
    });
  }

  closeFilterDropDown(): void {
    if(this.preferences.length > 0)
      if(this.filterDropdownPreference)
        this.filterDropdownPreference.hide();
  }

  onloadAssignee(event: any): void {
    if (this.searchUsers.length == 0) {
      this.loading = true;
      this.userProvider.getUsers(1)
        .subscribe(data => {
          if (data.success) {
            this.searchUsers = User.parseArray(data.result.items);
            this.dashboardService.setUsers(User.parseArray(data.result.items));
          }

          this.loading = false;
        });
    }
  }

  // Load Processors when hovers
  onloadProcessor(event: any): void {
    if (this.searchProcessor.length == 0) {
      this.loading = true;
      this.userProvider.getUsers(1, null, 'PROCESSOR')
        .subscribe(data => {
          if (data.success) {
            this.searchProcessor = User.parseArray(data.result.items);
            this.dashboardService.processors.next(User.parseArray(data.result.items));
          }

          this.loading = false;
        });
    }
  }

  // Load Research Analyst when hovers
  onloadResearchAnalyst(event: any): void {
    if (this.searchResearchAnalyst.length == 0) {
      this.loading = true;
      this.userProvider.getUsers(1, null, 'RESEARCH_ANALYST')
        .subscribe(data => {
          if (data.success) {
            this.searchResearchAnalyst = User.parseArray(data.result.items);
            this.dashboardService.researchAnalysts.next(User.parseArray(data.result.items));
          }

          this.loading = false;
        });
    }
  }

  // Load Financial Analyst when hovers
  onloadFinancialAnalyst(event: any): void {
    if (this.searchFinancialAnalyst.length == 0) {
      this.loading = true;
      this.userProvider.getUsers(1, null, 'FINANCIAL_ANALYST')
        .subscribe(data => {
          if (data.success) {
            this.searchFinancialAnalyst = User.parseArray(data.result.items);
            this.dashboardService.financialAnalysts.next(User.parseArray(data.result.items));
          }

          this.loading = false;
        });
    }
  }

  // Load Senior Analyst when hovers
  onloadSeniorAnalyst(event: any): void {
    if (this.searchSeniorAnalyst.length == 0) {
      this.loading = true;
      this.userProvider.getUsers(1, null, 'SENIOR_ANALYST')
        .subscribe(data => {
          if (data.success) {
            this.searchSeniorAnalyst = User.parseArray(data.result.items);
            this.dashboardService.seniorAnalysts.next(User.parseArray(data.result.items));
          }

          this.loading = false;
        });
    }
  }

  // Load Banks when hovers
  onLoadBanks(event: any): void {
    if (this.searchBanks.length == 0) {
      this.loading = true;
      this.clientProvider.getClients(1)
        .subscribe(data => {
          if (data.success) {
            this.searchBanks = Client.parseArray(data.result.items);
            this.dashboardService.setClients(Client.parseArray(data.result.items));
          }

          this.loading = false;
        });
    }
  }

  // on Search Tag Result
  onTagResult(value: string): void {
    this.tagProvider.search(value)
      .subscribe(data => {
        if (data.success)
          this.searchTags = Tag.parseArray(data.result.items);
      });
  }

  //Select Bank
  selectFilterTags(tag: Tag): void {
    const found = this.filterPreference.selectedTags.find(t => t.ID === tag.ID);
    if (!found)
      this.filterPreference.selectedTags.push(tag);
    this.setFilterBy('TAGS');
  }

  onLoadTags(event: any): void {
    if (this.searchTags.length == 0) {
      this.loading = true;
      this.tagProvider.getTags(1)
        .subscribe(data => {
          if (data.success) {
            this.searchTags = Tag.parseArray(data.result.items);
            this.dashboardService.tags.next(Tag.parseArray(data.result.items));
          }

          this.loading = false;
        });
    }
  }

  changeValue(event: any): void {
    this.onChangeValue.emit(event);
    // this.sliderValue = event.value;
    this.filterPreference.sliderValue = event.value;
    this.filterPreference.isChanged = true;
    this.saveSortColumn();
  }

  // Load Equipment Processor when hovers
  onloadEquipmentProcessor(event: any): void {
    if (this.searchEaProcessor.length == 0) {
      this.loading = true;
      this.userProvider.getUsers(1, null, 'EQUIPMENT_PROCESSOR')
        .subscribe(data => {
          if (data.success) {
            this.searchEaProcessor = User.parseArray(data.result.items);
            this.dashboardService.eqprocessors.next(User.parseArray(data.result.items));
          }

          this.loading = false;
        });
    }
  }

  // Load Equipment Research Analyst when hovers
  onloadEquipmentResearchAnalyst(event: any): void {
    if (this.searchEaResearchAnalyst.length == 0) {
      this.loading = true;
      this.userProvider.getUsers(1, null, 'EQUIPMENT_RESEARCH_ANALYST')
        .subscribe(data => {
          if (data.success) {
            this.searchEaResearchAnalyst = User.parseArray(data.result.items);
            this.dashboardService.eqresearchAnalysts.next(User.parseArray(data.result.items));
          }

          this.loading = false;
        });
    }
  }

  // Load Equipment Appraiser when hovers
  onloadEquipmentAppraiser(event: any): void {
    if (this.searchEaAppraiser.length == 0) {
      this.loading = true;
      this.userProvider.getUsers(1, null, 'EQUIPMENT_APPRAISER')
        .subscribe(data => {
          if (data.success) {
            this.searchEaAppraiser = User.parseArray(data.result.items);
            this.dashboardService.eqAppraiser.next(User.parseArray(data.result.items));
          }

          this.loading = false;
        });
    }
  }

  // Load Equipment Appraiser when hovers
  onloadEquipmentReviewer(event: any): void {
    if (this.searchEaReviewer.length == 0) {
      this.loading = true;
      this.userProvider.getUsers(1, null, 'EQUIPMENT_REVIEWER')
        .subscribe(data => {
          if (data.success) {
            this.searchEaReviewer = User.parseArray(data.result.items);
            this.dashboardService.eqReviewer.next(User.parseArray(data.result.items));
          }

          this.loading = false;
        });
    }
  }

  //Clear Selected Equipment Processor
  clearEProcessor(u: User, field: string): void {
    const index = this.filterPreference.selectedEaProcessor.findIndex(usr => usr.ID === u.ID);
    this.filterPreference.selectedEaProcessor.splice(index, 1);
    this.setFilterBy(field);
    this.scrollFilter('eqprocessor', true);
  }

  //Clear Selected Equipment Research Analyst
  clearEqResearchAnalyst(u: User, field: string): void {
    const index = this.filterPreference.selectedEaResearchAnalyst.findIndex(usr => usr.ID === u.ID);
    this.filterPreference.selectedEaResearchAnalyst.splice(index, 1);
    this.setFilterBy(field);
    this.scrollFilter('eqresearchAnalyst', true);
  }

  //Clear Selected Equipment Appraiser
  clearEqAppraiser(u: User, field: string): void {
    const index = this.filterPreference.selectedEaAppraiser.findIndex(usr => usr.ID === u.ID);
    this.filterPreference.selectedEaAppraiser.splice(index, 1);
    this.setFilterBy(field);
    this.scrollFilter('eqAppraiser', true);
  }

  //Clear Selected Equipment Reviewer
  clearEqReviwer(u: User, field: string): void {
    const index = this.filterPreference.selectedEaReviewer.findIndex(usr => usr.ID === u.ID);
    this.filterPreference.selectedEaReviewer.splice(index, 1);
    this.setFilterBy(field);
    this.scrollFilter('eqReviewer', true);
  }

  //Select Eq Processor
  selectFilterEqProcessor(user: User): void {
    const found = this.filterPreference.selectedEaProcessor.find(u => u.ID === user.ID);
    if (!found)
      this.filterPreference.selectedEaProcessor.push(user);

    this.setFilterBy('EQUIPMENT_PROCESSOR');
  }

  //Select Eq Research Analyst
  selectFilterEqResearchAnalyst(user: User): void {
    const found = this.filterPreference.selectedEaResearchAnalyst.find(u => u.ID === user.ID);
    if (!found)
      this.filterPreference.selectedEaResearchAnalyst.push(user);

    this.setFilterBy('EQUIPMENT_RESEARCH_ANALYST');
  }

  //Select Eq Appraiser
  selectFilterEqAppraiser(user: User): void {
    const found = this.filterPreference.selectedEaAppraiser.find(u => u.ID === user.ID);
    if (!found)
      this.filterPreference.selectedEaAppraiser.push(user);

    this.setFilterBy('EQUIPMENT_APPRAISER');
  }

  //Select Eq Reviewer
  selectFilterEqReviewer(user: User): void {
    const found = this.filterPreference.selectedEaReviewer.find(u => u.ID === user.ID);
    if (!found)
      this.filterPreference.selectedEaReviewer.push(user);

    this.setFilterBy('EQUIPMENT_REVIEWER');
  }

  loadParams(): void {
    let inStages: string[] = [];
    switch (this.paramStats) {
    case 'PENDING':
      if (this.currentMode == SystemType.EA)
        inStages = ['EAOR', 'EARI', 'EALS', 'EALR'];
      else
        inStages = ['ORDR', 'FBRI', 'ELST', 'ELRD'];
      break;
    case 'QUOTED':
      if (this.currentMode == SystemType.EA)
        inStages = ['EAQD'];
      else
        inStages = ['QUOT'];
      break;
    case 'IN_PROCESS':
      if (this.currentMode == SystemType.EA)
        inStages = ['EAED', 'EAAI', 'EASV', 'EARR', 'ERTA', 'EQAS', 'EQRV', 'EPFR', 'EARS', 'EARC', 'EADS', 'EARW', 'EAOO', 'EAPS'];
      else
        inStages = ['ENGD', 'STRT', 'SPCP', 'SPST', 'SPRE', 'R1DR', 'RDY1', 'REVW', 'RDY2', 'REV2', 'PHLR', 'VLCK', 'FINR', 'SUBR'];
      break;
    default:
      break;
    }
    if (inStages.length > 0) {
      for (const s of inStages) {
        if(this.stageService.getStageById(s)){
          this.filterPreference.selectedStages.push(this.stageService.getStageById(s));
        }
      }
    }
    this.retrieveSaveColumns();
    this.filterValueChanged();

  }

  onQuotesValueChanged(event: any): void {
    this.filterPreference.isChanged = true;
    this.saveSortColumn();
    this.filterValueChanged();
  }

  onResearchedValueChanged(): void {
    this.filterPreference.isChanged = true;
    this.filterValueChanged();
  }

  onSpreadedValueChanged(): void {
    this.filterPreference.isChanged = true;
    this.filterValueChanged();
  }

  clearResearched(): void {
    this.filterPreference.showResearched = false;
    this.filterPreference.isChanged = true;
    this.filterValueChanged();
  }

  clearSpreaded(): void {
    this.filterPreference.showSpreaded = false;
    this.filterPreference.isChanged = true;
    this.filterValueChanged();
  }

  onMiscValueChanged(misc: PresetValue, event: any): void {
    if (event)
      this.filterPreference.selectedMiscs.push(misc);
    else this.clearMiscs(misc, 'MISC');

    this.setFilterBy('MISC');
  }

  preferenceSelected(): boolean {
    return this.saveFilter.FIELD == "NO_SELECTED";
  }
}
